var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageWrapper',[_c('div',{staticClass:"feedback"},[_c('div',{attrs:{"data-pp-cfpw-widget":"3f60cac8-7398-11e7-a604-0288f735e5b9","data-env":"prod","data-static":"false"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }